import React from 'react';
import { Link, withRouter } from 'react-router-dom';

import Header from '../Header';
import { getToken } from '../../constants/localStorageManager';
import SocialIcons from '../LandingPage/SocialIcons';

const OnboardingWrapper = ({ children, history, isModalActive }) => {
  const exitOnboarding = () => {
    history.push('/');
  }

  return (
    <main>
      <header className="main-header position-relative">
        <div className={`${!isModalActive ? "exit-onboarding" : "d-none"}`}>
          <span className="cursor-pointer" onClick={exitOnboarding}>
            Quit Guided Tour
          </span>
        </div>
        <div className="container disable-actions">
          <div>
            <Header />
          </div>
        </div>
      </header>
      <div className="main-body clearfix">
        {children}
      </div>
      <footer className="text-muted pt-4 pb-4 disable-actions">
        <div className="container">
          <p className="float-right">
            {!getToken() ? <a href="/home#growBusiness">About Us</a> : null}
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-of-use">Terms and Conditions</Link>
          </p>
          <p>
            ©
          {' '}
            {new Date().getFullYear()}
            {' '}
            All rights reserved by
          {' '}
            <Link to="/home">Soono</Link>
            .
            <SocialIcons />
        </p>
        </div>
      </footer>
    </main>
  )
}

export default withRouter(OnboardingWrapper);



// WEBPACK FOOTER //
// ./src/components/Onboarding/OnboardingWrapper.js